
import React from "react";
import Layout from "@/components/layout/Layout";
import { SectionHeader } from "@/components/ui/section-header";
import { Helmet } from "react-helmet";
import { JobApplicationForm } from "@/components/jobs/JobApplicationForm";
import { useCounties } from "@/hooks/use-counties";

export default function JobsPage() {
  const { data: counties } = useCounties();
  
  return (
    <Layout>
      <Helmet>
        <title>Jobs | Grandpal</title>
      </Helmet>
      
      <div className="container max-w-4xl py-16">
        <SectionHeader 
          title="Join Our Team"
          subtitle="Help us make a difference in elderly care across Ireland"
          centered
        />
        
        <div className="bg-white rounded-lg shadow-sm border p-6">
          <h3 className="text-xl font-semibold mb-6">Apply Now</h3>
          <JobApplicationForm 
            counties={counties ? counties.map(county => ({
              county: county.name,
              county_slug: county.slug
            })) : []} 
          />
        </div>
      </div>
    </Layout>
  );
}
